import type { FaireProductEntity } from "../../entity_types/product";

export const p_ezg83hm7nu: FaireProductEntity = {
  token: "p_ezg83hm7nu",
  type: "product",
  name: "4oz  Candle Gift Set - Nature Collection",
  brandToken: "b_p8rcsml9xr",
  brandName: "Lineage",
  imageUrl:
    "https://cdn.faire.com/fastly/320bf9f3b6ed490b1dc6a16a7232573b9103705ef88c92f84a073d9158556b2f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7768540363f2bcd32800bb6aa3d32a939d0d433815d03e9daaaae7f1c031b4f9.jpeg",
  ],
  priceDollars: 24,
  description:
    "A collection of three 4 oz candles, curated from some of our best-selling and most beloved scents, inspired by nature. Packaged in a brown kraft gift box, this would make a perfect gift for all occasions. It’s also a great way for new customers to explore some of our most popular candles.\n\nContains: Eucalyptus & Birch, Palo Santo, Wildwood\n\nEach candle comes in a 4 oz amber glass jar with black screw-on lid. Each candle has an approximate 16-20 hour burn time.\n\nBox measures 8 x 2.75 x 3\nHand poured in Richmond, Virginia",
  tags: [],
  msrpDollars: 48,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:51:29.057Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
